module.exports = __webpack_public_path__ + "img/Revenue.89db1215.svg";